import {Component, Input, OnInit} from '@angular/core';
import {IconEventos, urlIconStatus} from '~utils/zindex-status-monitoramento';
import {IconeVo} from '~model/vo/rota-vo';
import {IconService} from '~core/utils/icon.service';
import {take} from 'rxjs/operators';

@Component({
  selector: 'app-state-circle',
  templateUrl: './state-circle.component.html',
  styleUrls: ['./state-circle.component.scss'],
})
export class StateCircleComponent implements OnInit {
  @Input() visit: IconeVo = {};
  @Input() iconMini: boolean = false;
  @Input() color: string = '#212121';
  @Input() flag: boolean = false;
  iconText: string = '';
  toolTip: string = '';

  fontSize: string = '';
  imageIcon: string = '';
  matColor: string = '#555';
  matSecundary: string = 'transparent';

  constructor (
    private iconsService: IconService
  ) {}

  ngOnInit(): void {
    if (!this.visit) {
      this.visit = {};
    }

    const matIcon = IconEventos[this.visit.evento ?? ''] ?? IconEventos[this.visit.grupo ?? ''];
    if (matIcon) {
      this.visit = { ...this.visit, matIcon };
    }

    if (this.flag) {
      this.visit.matIcon = 'flag';
      this.matColor = '#47aa00';
    } else if (this.visit.matIcon) {
      if (this.visit.matIcon.includes('report')) {
        this.matColor = '#ff1200';
        this.matSecundary = '#fff300';
      }
    }

    if ([70, 90].includes(this.visit.iconID ?? 0)) {
      this.visit.iconID = undefined;
    }
    if (this.visit.iconID !== undefined && !['INICIOALMOCO', 'FIMALMOCO'].includes(this.visit.evento ?? '')) {
      this.imageIcon = `url(${urlIconStatus(this.visit, this.color)})`;
    }

    this.iconsService.getTooltip(this.visit).pipe(take(1)).subscribe(toolTip => {
      this.toolTip = toolTip;
      this.fontSize = '85%';
    });
  }
}
